export const paletteOrange = {
  primary: {
    lighter: '#FFF3E0',
    light: '#FFB74D',
    main: '#F57C00', // Orange 700
    dark: '#E65100',
    darker: '#BF360C', 
    contrastText: '#ffffff',
  },
  secondary: {
    lighter: '#FFF8E1',
    light: '#FFD54F',
    main: '#FFC107', // Amber
    dark: '#FFA000',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  error: {
    light: '#EF5350',
    main: '#D32F2F',
    dark: '#C62828',
    contrastText: '#fff',
  },
  warning: {
    light: '#FFF9C4',
    main: '#FBC02D',
    dark: '#F57F17',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  success: {
    light: '#C8E6C9',
    main: '#2E7D32',
    dark: '#1B5E20',
    contrastText: '#fff',
  },
  info: {
    main: '#0288D1', 
    light: '#03A9F4', 
    dark: '#01579B', 
    contrastText: '#fff'
  },
  background: {
    default: '#FCF7F2',
    paper: '#FFFFFF',
    neutral: '#F9F4EF',
  },
  text: {
    primary: '#2D2D2D', 
    secondary: '#5E5E5E', 
    disabled: '#9E9E9E', 
  },
  divider: '#EEEEEE',
  brand: {
    main: '#E65100',
    light: '#FFB74D',
    lighter: '#FFF3E0',
    dark: '#BF360C',
    contrastText: '#ffffff',
    headerBg: '#F57C00',
    headerText: '#ffffff',
    rowHover: '#FFF3E0',
  },
};
